<template>
    <div style="width:100%;height:100%;position:absolute;inset-inline-start:0;top:0;">
       <img ref="storybaordImagePreviewRef" style="width:100%;height:100%;position:relative;z-index:1;"/>
    </div>
</template>

<script>
import Utils from '../../components.utils.js';
import {mapActions} from 'vuex';
export default {
    name: 'StoryBoardThumbnailPreview',
    props:['assetDetails'],
    data(){
        return {
            previewLoadMap:{},
            storyBoardList:[],
            percentageRegex:  /(\d{1,2})(.(\d{0,}))/,
            imagesStoryBoardMap: {},
            isStoryBoardFetchError: false,
        }
    },
    methods:{
        getImagesWidth(){
            // return Math.abs(this.storyBoardList.length / );
        },

        showImageOnHover(percentage){
           if(this.isStoryBoardFetchError) return;
           let per, isInZeroNdNinety = false;
           console.log(per);
           if(percentage > 90){
                per  =  100;
                isInZeroNdNinety = true;
           }else if(percentage == 0){
              per = 10;
              isInZeroNdNinety = true;
           }
           if(percentage < 0) return;
           if(!isInZeroNdNinety){
                per = String(percentage).replace(this.percentageRegex,'$1');
                let re = /(\.)/;
                let newPer = Number(per) / 10;
                if(re.test(String(newPer))){
                    per = Number(per) / 10;
                    per = Number(String(per).replace(this.percentageRegex,'$1')) * 10;
                }
                if(per == 0) per = 10;
                if(Number(per) < 0){
                    per = 10;
                }
           }
            console.log(`[Display storyboard at]`,per);
           if(this.imagesStoryBoardMap[per])
               this.$refs.storybaordImagePreviewRef.src = this.imagesStoryBoardMap[per];
        },
        ...mapActions('proxy',['getStoryboardFromServer'])
    },
    created(){
       if(!this.previewLoadMap[this.assetDetails._id]){
           this.previewLoadMap[this.assetDetails._id] = this.assetDetails;
           let storyBoardUrl = this.assetDetails.proxy_info.storyboard_uri;
           this.getStoryboardFromServer(storyBoardUrl).then(storyBoardList =>{
                storyBoardList = storyBoardList.map(storyBoardObj => {
                    return `${storyBoardUrl}/${storyBoardObj.name}`
                });
                this.storyBoardList = storyBoardList;
                this.storyBoardList.forEach((url,i) =>{
                      this.imagesStoryBoardMap[(i + 1) * 10] = Utils.convertToLoginIPDomainName(url);
                });
           }).catch(() => {
             this.storyBoardList = [];
             this.isStoryBoardFetchError = true;
          });
       }
    }
}
</script>

<style scoped>
img[src=""], img:not([src]) {
  display: none;
}
</style>